import { render, staticRenderFns } from "./DeviationsEdit.vue?vue&type=template&id=324a3811&lang=pug"
import script from "./DeviationsEdit.vue?vue&type=script&lang=ts"
export * from "./DeviationsEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports